import getActions from "./actionsPopupUtils";

const foreign_labor_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default foreign_labor_actions;
